export const FETCH_RANKLIST_BEGIN = 'FETCH_RANKLIST_BEGIN';
export const FETCH_RANKLIST_SUCCESS = 'FETCH_RANKLIST_SUCCESS';
export const FETCH_RANKLIST_ERROR = 'FETCH_RANKLIST_ERROR';